export enum ETrafficStudyManageTab {
  OVERVIEW = "overview",
  CONFIG = "config",
  COLLECTED_DATA = "collected-data",
  REPORTS = "reports",
  HISTORY = "history",
  LOGS = "logs",
}
